// src/firebase.js
import firebase from 'firebase';
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const config = {
  apiKey: 'AIzaSyA0JpNrsYm0Gy92f4SVM0l-NMQYSF0s8t8',
  authDomain: 'funding-web-tool.firebaseapp.com',
  projectId: 'funding-web-tool',
  storageBucket: 'funding-web-tool.appspot.com',
  messagingSenderId: '79146879331',
  appId: '1:79146879331:web:6889d95326fedaf56c6b56',
  measurementId: 'G-9MC6SC1MH2',
};
firebase.initializeApp(config);
export default firebase;
